import React, { createContext, useContext, useState, useCallback } from 'react'
import { nl } from './nl'

const LanguageContext = createContext()
const storedLanguage = () => { try { return localStorage.getItem('lang') || 'nl' } catch { return 'nl' } }
const storeLanguage = value => { try { localStorage.setItem('lang', value) } catch { /* Private/blocked storage: keep this session usable. */ } }

// Simple interpolation: t('Found {count} listings', { count: 5 })
function interpolate(str, vars) {
  if (!vars) return str
  return str.replace(/\{(\w+)\}/g, (_, key) => vars[key] !== undefined ? vars[key] : `{${key}}`)
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(storedLanguage)

  const toggleLang = useCallback(() => {
    setLang(prev => {
      const next = prev === 'en' ? 'nl' : 'en'
      storeLanguage(next)
      return next
    })
  }, [])

  const setLanguage = useCallback((newLang) => {
    storeLanguage(newLang)
    setLang(newLang)
  }, [])

  // t('English string') → returns Dutch if lang=nl, English otherwise
  // t('Hello {name}', { name: 'John' }) → interpolation
  const t = useCallback((key, vars) => {
    if (lang === 'nl' && nl[key]) {
      return interpolate(nl[key], vars)
    }
    return interpolate(key, vars)
  }, [lang])

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLang, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useTranslation() {
  const ctx = useContext(LanguageContext)
  if (!ctx) throw new Error('useTranslation must be used within LanguageProvider')
  return ctx
}
